import { render, staticRenderFns } from "./BaseText.vue?vue&type=template&id=b313ca3c&scoped=true&"
import script from "./BaseText.vue?vue&type=script&lang=js&"
export * from "./BaseText.vue?vue&type=script&lang=js&"
import style0 from "./BaseText.vue?vue&type=style&index=0&id=b313ca3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b313ca3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
